module.exports = "<div class=\"bp-hint fade\">\n    <h3 class=\"popover-title\">{{title}}</h3>\n    <div class=\"popover-content\">{{content}}</div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/service/hint/hint.html
 ** module id = 209
 ** module chunks = 0
 **/